import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonListProps {
  columns?: number;
  hasAvatar?: boolean;
  animation?: SkeletonAnimation;
}

export const SkeletonList: React.FC<SkeletonListProps> = ({
  columns = 5,
  animation = 'wave',
}) => {
  const itemIndexes = Array.from({ length: columns });

  return (
    <div className="table-container">
        <table className="skeleton-table">
          <tbody>
            {itemIndexes.map((_, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {itemIndexes.map((_, colIndex) => (
                  <td key={`cell-${rowIndex}-${colIndex}`}>
                    <div className="line" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  );
};

export default SkeletonList;
